





























import Vue from 'vue'
import dayjs from 'dayjs'
export default Vue.extend({
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    scrollY: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dayjs
    }
  },
  methods: {
    icon(file) {
      let icon = 'file-unknown'
      if (file.isfolder === true) {
        icon = 'folder'
      } else {
        if (file.contentType && file.contentType.indexOf('image/') !== -1) {
          icon = 'file-image'
        } else {
          icon = 'file-text'
        }
      }
      return icon
    },
    color(file) {
      let color = '#52c41a'
      if (file.isfolder === true) {
        color = '#ffe17b'
      } else {
        if (file.contentType && file.contentType.indexOf('image/') !== -1) {
          color = '#71ce52'
        } else {
          color = '#92a8c1'
        }
      }
      return color
    }
  }
})
